import { createElement } from 'react';
import type { GameDescriptor } from '../game-registry.js';

// Keno owns its entire surface via the DOM `KenoGrid` (selection + animated reveal),
// rendered directly by GamePage — it never goes through the Pixi GameStage path. The
// descriptor's `scene` field is still required by the type, so it points at a no-op.
function KenoNoScene() {
  return createElement('div', { 'data-keno-noscene': true });
}

export const kenoDescriptor: GameDescriptor = {
  code: 'keno',
  scene: KenoNoScene,
  supportsAuto: true,
  selectable: true,
};
